import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ListTable from "../../molecules/ListTable";
import { useReviewList } from "../../../api/review/hooks";
import { useDispatch } from "react-redux";
import { closeLoader, openLoader } from "../../../store/loaderSlice";
import styled, { css } from "styled-components";
import StatusBadge from "../../atoms/StatusBadge";
import Paging from "../../organisms/Paging";

/**
 * 참여할 리뷰 목록
 * - 일반 사용자용 화면
 */
const ReviewList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [pageNum, setPageNum] = useState(1);
    const [viewCount, setViewCount] = useState(15);
    const { data, isLoading, refetch } = useReviewList(pageNum, viewCount);
    const reviewList = data?.data?.review || [];

    useEffect(() => {
        dispatch(openLoader());
    }, [dispatch]);

    useEffect(() => {
        refetch();
    }, [pageNum, viewCount, refetch]);

    useEffect(() => {
        isLoading ? dispatch(openLoader()) : dispatch(closeLoader());
    }, [dispatch, isLoading]);

    return (
        <>
            <h2>참여할 리뷰</h2>

            <div>
                <ListTable>
                    <thead>
                        <tr>
                            <th style={{ width: "5%" }} className="center">번호</th>
                            <th style={{ width: "70%" }}>제목</th>
                            <th style={{ width: "15%" }}>진행도</th>
                            <th style={{ width: "10%" }}>생성 날짜</th>
                        </tr>
                    </thead>

                    <tbody>
                        { reviewList?.length > 0
                            ? reviewList?.map((el) => {
                                const step = el.completed_reviewee_count === "0" ? "0" : el.completed_reviewee_count === el.total_reviewee_count ? "1" : "2"
                                
                                return (
                                    <ReviewRow className="hover-row" key={el.seq} active={el.status === "2"} onClick={() => navigate(`/review/detail/${el.idx}`)}>
                                        <td className="seq">{el.seq}</td>
                                        <td className="left">
                                            {/* <span className={`status status-${el.status}`}>{el.is_hide === "1" ? "삭제" : el.status === "1" ? "대기" : el.status === "2" ? "진행" : el.status === "3" ? "확인" : el.status === "4" ? "종료" : null}</span> */}
                                            <span className="review-title">{el.title}</span>
                                        </td>
                                        <td>
                                            <StatusBadge step={step} />
                                            <ProgressSpan>{el.completed_reviewee_count}/{el.total_reviewee_count}건</ProgressSpan>
                                        </td>
                                        <td className="date">{el.reg_date.split("T")[0]}</td>
                                    </ReviewRow>
                                );
                            })
                            : (
                                <tr className="empty-row">
                                    <td colSpan={4}>
                                        리뷰가 없습니다
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </ListTable>
            </div>

            <Paging name={"review_list"} total={parseInt(data?.data?.total)} pageNumState={[pageNum, setPageNum]} viewCount={viewCount}></Paging>
        </>
    );
};

const ReviewRow = styled.tr`
    height: 58px;
    ${(props) =>
        props.active === false &&
        css`
            td {
                color: var(--lightgray-color);
                background-color: var(--light-color);
                pointer-events: none;
            }
        `}

    .review-title {
    }
`;

const ProgressSpan = styled.span`
    margin-left: 8px;
`;

export default ReviewList;